import React from 'react';
import { Form, Input, Button, Divider, } from 'antd';
import {LogoutHandler} from './layout/operation/Logout'
const FormItem = Form.Item;



class ModifyPasswordC extends React.Component {
  state = {

  };
  encrypt(val) {
    if(!sgiConfig.PublicKey) return val
    var encrypt = new JSEncrypt()
    encrypt.setPublicKey(sgiConfig.PublicKey)
    return encrypt.encrypt(val)
  }
  UamUserInfoQuery(values) {
    console.log(values)
    let req = {
      "loginPwd": this.encrypt(values.oldPassword),
      "newPwd": this.encrypt(values.newPassword),
      userId: tool.getCookie('userId')
    };
    console.log(req)
    var success = function (res) {
      console.log(res)
      tool.sgiLogger.info(res, 'UamUserInfoQuery')
      if (res && res.head.code == "0000") {
        // 退出  重新登录
        LogoutHandler()
        tool.popMessage('操作成功，请重新登录', "success");
      } else {
        tool.popMessage(res.head.msg, "warning");
        return;
      }
    };
    console.log(sgiConfig.allUrl.UamUserInfoQuery)
    commonClient.simplecall(sgiConfig.allUrl.UamUserInfoQuery, req, success)
  }
  handleSubmit = (e) => {
    var me = this;
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        tool.sgiLogger.info('Received values of form: ', values);
        this.UamUserInfoQuery(values);
      }
    });
  }
  handleConfirmPassword = (rule, value, callback) => {
    const { getFieldValue } = this.props.form
    if (value && value !== getFieldValue('newPassword')) {
      callback('两次输入不一致！')
    }

    // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
    callback()
  }
  jumpUrl = (params) => {
    // tool.popSingleUI('/')
    tool.goBack(-1)
    // browserHistory.push({
    //   pathname: '/'
    // });
  }
  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };


    return (
      <div style={{ width: '420px', margin: '100px auto 0' }}>
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="旧密码"
          >
            {getFieldDecorator('oldPassword', {
              rules: [{
                required: true, message: '请填写旧密码!',
              }],
            })(
              <Input type="password" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="新密码"
          >
            {getFieldDecorator('newPassword', {
              rules: [{
                required: true, message: '请填写新密码!'},
                {
                  // pattern: /^.*(?=.*[A-Z]{1,})(?=.*[a-z]{1,})[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,16}$/,
                  pattern: /^(?![A-Za-z0-9]+$)(?![a-z0-9\W]+$)(?![A-Za-z\W]+$)(?![A-Z0-9\W]+$)^.{8,16}$/,
                  message:'长度8-16位，必须包含数字、大写字母、小写字母、特殊字符'
                }
              ],
            })(
              <Input type="password" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="确认新密码"
          >
            {getFieldDecorator('confirmNewPassword', {
              rules: [{
                required: true, message: '请填写确认密码!',
              }, {
                validator: this.handleConfirmPassword
              }],
            })(
              <Input type="password" />
            )}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">提 交</Button>
            <Button type="primary" onClick={this.jumpUrl} style={{marginLeft:'20px'}}>取 消</Button>
          </FormItem>
        </Form>
      </div>

    );
  }
}

const ModifyPassword = Form.create()(ModifyPasswordC);
export default ModifyPassword


// WEBPACK FOOTER //
// ./apps/pages/main/ModifyPassword.js